import * as React from "react";
const matchContext = React.createContext(void 0);
const dummyMatchContext = React.createContext(
  void 0
);
export {
  dummyMatchContext,
  matchContext
};
//# sourceMappingURL=matchContext.js.map
